/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'availability-zone';

export const availabilityZoneLabel = `${prefix}.availabilityZoneLabel`;

export const ENGLISH = {
    [availabilityZoneLabel]: 'Availability Zone',
};
